import generatedMadPawsTheme from '@rover/kibble/tokens/build/madpaws/es6/theme';

import { breakpoints } from './themeConstants';

const madpawsTheme = {
  ...generatedMadPawsTheme,
  breakpoints,
};

export default madpawsTheme;
